import { useState } from 'react';
import { signedContractRepository } from '../repository/signedContract.repository';
import useLoadSignedContracts from './useLoadSignedContracts';

const useGenerateContract = (orderId: string) => {
  const { loadSignedContracts } = useLoadSignedContracts(orderId);
  const [isGenerating, setIsGenerating] = useState(false);

  const generate = async () => {
    setIsGenerating(true);

    try {
      const response = await signedContractRepository().createEmptySignedContract(orderId);
      if (response.ok) {
        await loadSignedContracts();
      }
    } finally {
      setIsGenerating(false);
    }
  };

  return { generate, isGenerating };
};

export default useGenerateContract;
